<template>
    <div id="pagination">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="limit" :current-page="offset"
                       @current-change="changePage">
        </el-pagination>
        <div class="pageFoot">共 {{total}} 条数据</div>
    </div>
</template>

<script>
    export default {
        name: "pagination",
        props: {
            limit:{default: 15},
            offset: {required: true, default: 1},
            total: {required: true, default: 0},
        },
        methods:{
            changePage(val){
                this.$emit("changePage", val-1)
            }
        }
    }
</script>

<style scoped>
    #pagination{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0;
    }
    #pagination > .pageFoot{
        font-size: 14px;
        color: #8590a6;
    }
</style>